import { render, staticRenderFns } from "./TurmasPorUnidade.vue?vue&type=template&id=26913fd9&scoped=true"
import script from "./TurmasPorUnidade.vue?vue&type=script&lang=js"
export * from "./TurmasPorUnidade.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26913fd9",
  null
  
)

export default component.exports